import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import HomeDashboardLayout from '../HomeDashboardLayout';
import MyWalletSidebar from '../MyWalletSidebar';
import HeaderProfileSection from '../HeaderProfileSection';
import { useDoubtFilters, useSaveDoubt } from '../../hooks/useDoubts';
import { getStoredUser } from '../../utils/authStorage';
import { buildDoubtFlowState } from './doubtFlowState';
import { DOUBT_ROUTES } from './doubtRoutes';
import { buildDoubtDraft } from './doubtDraftState';
import '../../dashboard/Dashboard.css';
import '../HomeDashboard.css';
import './DoubtCategory.css';
import './DoubtSubCategories.css';
import './DoubtFlowLayout.css';

const toggleId = (values, id) => values.includes(id) ? values.filter((value) => value !== id) : [...values, id];

const DoubtSubCategory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const storedUser = getStoredUser();
  const flow = useMemo(() => buildDoubtFlowState(location.state), [location.state]);
  const [draft, setDraft] = useState(() => buildDoubtDraft(location.state?.doubtDraft));
  const language = String(flow?.language || storedUser?.content_language || storedUser?.language || 'EN').toUpperCase();
  const filterQuery = useDoubtFilters(Number(flow?.category_id || 2), language, true, 0);
  const filterData = location.state?.doubtFilterData || filterQuery.data;
  const save = useSaveDoubt();
  const selectedSubjects = (filterData?.subjects || []).filter((subject) => draft.subjectIds.includes(subject.id));
  const isSaving = save.create.isPending || save.edit.isPending;
  const post = async () => {
    Swal.fire({
      title: 'Saving...',
      text: 'Please wait while we save your doubt.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    const payload = { doubtId: draft.doubtId, title: draft.title, description: draft.description, subjectIds: draft.subjectIds, topicIds: draft.topicIds, tagCategoryIds: draft.tagCategoryIds, attachments: draft.newAttachments, deleteAttachmentIds: draft.deleteAttachmentIds };
    try {
      if (draft.doubtId) await save.edit.mutateAsync(payload);
      else await save.create.mutateAsync(payload);
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: draft.doubtId ? 'Doubt updated successfully.' : 'Doubt posted successfully.',
        timer: 1500,
        showConfirmButton: false
      });
      navigate(flow?.qbankBackTarget?.pathname || DOUBT_ROUTES.list, { replace: true, state: flow?.qbankBackTarget?.state || flow });
    } catch (error) {
      let errorText = error?.message || 'Unable to save your doubt.';
      const validationErrors = error.backend?.dataset?.data;
      if (validationErrors && typeof validationErrors === 'object') {
        const messages = [];
        for (const [field, errors] of Object.entries(validationErrors)) {
          if (Array.isArray(errors)) messages.push(errors[0]);
          else if (typeof errors === 'string') messages.push(errors);
        }
        if (messages.length > 0) errorText = messages.join('\n');
      }
      
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorText,
      });
    }
  };
  return <HomeDashboardLayout showHeader={false} variant="doubt-flow-layout"><div className="qbl-page qbankList-page askDoubt doubt-subcategories p-0"><div className="start-quiz qbl-main qbl-panel"><div className="hideProfile-page"><div className="categories-page-header mb-0"><button type="button" className="categories-back-button" onClick={() => navigate(-1)} aria-label="Go back"><i className="bi bi-chevron-left" /></button><h4 className="d-flex d-sm-none categories-page-title"><span className="visually-hidden">Select topics</span></h4><HeaderProfileSection /></div></div><h1 className="qb-title">Select <span>Topics</span></h1><p className="qb-sub">Add related topics before posting your doubt.</p><div className="related-topics-section">{filterQuery.isLoading && !filterData ? <div className="doubt-filter-status">Loading topics...</div> : null}{selectedSubjects.length ? selectedSubjects.map((subject) => <div className="related-subject-wrapper" key={subject.id}><button type="button" className="related-subject" onClick={() => setDraft((current) => ({ ...current, subjectIds: current.subjectIds.filter((id) => id !== subject.id) }))}><span className="related-subject__name">{subject.name}</span><span className="related-subject__icon"><i className="bi bi-x-lg" /></span></button>{subject.topics?.length ? <div className="related-chapters">{subject.topics.map((topic) => <button type="button" className={`related-chapter${draft.topicIds.includes(topic.id) ? ' related-chapter--selected' : ''}`} key={topic.id} onClick={() => setDraft((current) => ({ ...current, topicIds: toggleId(current.topicIds, topic.id) }))}><span>{topic.name}</span><span className="related-chapter__icon"><i className={`bi ${draft.topicIds.includes(topic.id) ? 'bi-x-lg' : 'bi-plus-lg'}`} /></span></button>)}</div> : <p className="doubt-filter-status">No topics available for this subject.</p>}</div>) : <p className="doubt-filter-status">No subject selected. You can still post this doubt.</p>}</div><div className="navigationFixed suggested-subjects-navigation"><div className="result-bottom-nav"><button type="button" className="ask-doubt-modal__next subjectBtn" onClick={post} disabled={isSaving}>{isSaving ? 'Saving...' : draft.doubtId ? 'Update' : 'Post'}</button></div></div></div></div><MyWalletSidebar withTopOffset={false} /></HomeDashboardLayout>;
};

export default DoubtSubCategory;
